import { Box, BoxProps, ButtonNew, ButtonProps, ColorOptions, Icon, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { TextStyle } from 'react-native'
import { ModBox } from '../../../comps/ModifiedBox/ModifiedBox'

interface HeaderProps {
  id: string
  status: string
  onPause: () => void
  onCancel: () => void
  onDismiss: () => void
  invoice: string
}

const getBackgroundColor = (value: string) => {
  type colorType = {
    [key: string]: any
  }
  const getColor: colorType = {
    ACTIVE: styles.active,
    INITIATED: styles.active,
    SUCCESS: styles.active,
    FAILED: styles.failed,
    CANCELED: styles.failed,
  }

  return getColor[value] ?? styles.bgDefault
}

const getTextColor = (value: string) => {
  type colorType = {
    [key: string]: string
  }
  const getColor: colorType = {
    ACTIVE: 'GREEN_C',
    SUCCESS: 'GREEN_C',
    INITIATED: 'GREEN_C',
    FAILED: 'RED_C',
    CANCELED: 'RED_C',
  }
  return (getColor[value] as ColorOptions) ?? 'BLACK_21'
}

const getTextOpacity = (value: string) => {
  type opacityType = {
    [key: string]: number
  }
  const getOpacity: opacityType = {
    Active: 1,
  }
  return getOpacity[value] ?? 1
}

const Header: FC<HeaderProps> = ({ id, status, onPause, onCancel, onDismiss, invoice }: HeaderProps) => {
  return (
    <Box {...styles.container}>
      <Box>
        <Box flexDirection={'row'}>
          <TextNew type="body18" color="BLACK_21" fontFamily={'jiotype-bold'}>
            {invoice}
          </TextNew>
          <Box flexDirection={'row'}>
            <Spacer size={8} direction="horizontal" />
            <Box {...getBackgroundColor(status)}>
              <TextNew
                type="body12"
                color={getTextColor(status)}
                opacity={getTextOpacity(status)}
                fontFamily={'jiotype-medium'}>
                {status}
              </TextNew>
            </Box>
          </Box>
        </Box>
        <TextNew
          type="label"
          fontSize={12}
          color={'GREY_77' as ColorOptions}
          fontFamily={'jiotype-medium'}
          testID={'subscriptionsTxnID'}>
          {id}
        </TextNew>
      </Box>
      <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <Box flexDirection="row">
          <ModBox show={false} flexDirection="row">
            <ButtonNew {...styles.button} title="Cancel" onPress={() => onCancel && onCancel()} />
            <Spacer size={8} direction="horizontal" />
            <ButtonNew {...styles.button} title="Pause" onPress={() => onPause && onPause()} />
            <Spacer size={8} direction="horizontal" />
          </ModBox>
          <Box onPress={onDismiss} {...styles.close}>
            <Icon id="CLOSE" size="FONT_SIZE_LARGE_3P" color={'GREY_C' as ColorOptions} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    paddingHorizontal: 24,
    paddingVertical: 16,
    borderBottomColor: 'SEPARATOR' as ColorOptions,
    borderBottomWidth: 1,
    flexDirection: 'row',
    justify: 'space-between',
  } as BoxProps,
  close: {
    alignSelf: 'center',
    underlayColor: 'WHITE',
  } as BoxProps,
  button: {
    paddingHorizontal: 8,
    type: 'secondarySmall',
    borderColor: 'PRIMARY',
    titleColor: 'PRIMARY',
    borderRadius: 'SMALL',
    borderWidth: 1,
  } as ButtonProps,
  active: {
    backgroundColor: '#11C13A1A',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    borderRadius: 4,
    paddingHorizontal: 6,
  } as TextStyle,
  failed: {
    backgroundColor: 'RED_BG_C',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    borderRadius: 4,
    paddingHorizontal: 6,
  } as TextStyle,
  bgDefault: { backgroundColor: 'WHITE' },
}

export { Header }
